export enum STATUS_CODES {
  FORBIDDEN = 403,
  INVALID_PROFILE = 412,
  CONTENT_TOO_LARGE = 413,
}
